import { computed, ref } from '@vue/composition-api'

export const validationObservers = ref([])

export const registerValidationForm = validationObserver => {
	validationObservers.value.push(validationObserver)
}

export const unregisterValidationForm = uid => {
	validationObservers.value = validationObservers.value.filter(({ _uid }) => _uid !== uid)
	setFormChangedValue(false)
}

export const formChangedValue = ref(false)

export const setFormChangedValue = value => {
	formChangedValue.value = value
}

export const getFormChangedValue = computed({
	get () {
		return formChangedValue.value
	},
	set (value) {
		setFormChangedValue(value)
	}
})
